import {baseRequest} from './base';

//获取appModule列表
function getAppModuleList(params){
  let tempUrl = '/api/parentapp/appModule';
  return baseRequest(tempUrl,'get',params);
}

//新增appModule
function add(params){
  let tempUrl = '/api/parentapp/appModule';
  return baseRequest(tempUrl,'post',params);
}

//修改appModule
function edit(params){
  let tempUrl = '/api/parentapp/appModule';
  return baseRequest(tempUrl,'put',params);
}

//删除appModule
function del(params){
  let tempUrl = '/api/parentapp/appModule/'+params.id;
  return baseRequest(tempUrl,'delete');
}

//详情
function detail(params){
  let tempUrl = '/api/parentapp/appModule/'+params.id;
  return baseRequest(tempUrl,'get');
}

export default {
  getAppModuleList,add,edit,del,detail
}
